import { CONST } from "../sideTypes"
import { MenuItemCategory, MenuItemType } from "../../Components/navigationTypes"

export const builderConnectList: Array<MenuItemType> = [
    {
        label: "NewHomeConnect",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "Connect to a Deal",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    reactFrame: 'connectinfile',
                    controller: {
                        tabName: "NewHome",
                    }
                },
                addOptions: [],
                type: MenuItemCategory.Default,
                requiredFields: [{ field: "getVIPInfoMsgID", isNull: true }]
            },
            {
                label: "Import Information",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    reactFrame: 'builderinfo',
                    controller: {
                        tabName: "NewHome",
                    }
                },
                addOptions: [],
                type: MenuItemCategory.Default,
                requiredFields: [{ field: "getVIPInfoMsgID" }]
            },
            {
                label: "Documents from Seller Side",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    reactFrame: 'builderdoc',
                    controller: {
                        tabName: "NewHome",
                    }
                },
                addOptions: [],
                type: MenuItemCategory.Default,
                requiredFields: [{ field: "getVIPInfoMsgID" }]
            },
            {
                label: "Documents for eSigning",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    reactFrame: 'builderesign',
                    controller: {
                        tabName: "NewHome",
                    }
                },
                addOptions: [],
                type: MenuItemCategory.Default,
                requiredFields: [{ field: "getVIPInfoMsgID" }]
            },
        ],
        addOptions: [
            {
                label: "Disconnect",
                appCode: ["RPW", "RPWBC"],
                navigate: {
                    component: "main",
                    controller: {
                        tabName: 'Basic',
                        onClickDispatch: 'DRDisconnect'
                    }
                },
                addOptions: [],
                type: MenuItemCategory.Default,
                requiredFields: [{ field: "getVIPInfoMsgID" }]
            },
        ],
        addOptionsType: "ellipsis",
        type: MenuItemCategory.Heading,
        PSM: "P",
        requiredFields: [{ field: "getNewHome", value: "0" }]
    }
]
